import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { CustomCommandBarComponent } from './custom-command-bar.component';

@NgModule({
  declarations: [CustomCommandBarComponent],
  imports: [
    CommonModule,
    IonicModule, // Import IonicModule for ion-icon and other Ionic components
    FormsModule, // Import FormsModule for ngModel or input event handling if needed
  ],
  exports: [CustomCommandBarComponent], // Export the component so it can be used in other modules
})
export class CustomCommandBarModule {}
